import React from 'react';
import './PaymentMethodDisplay.css';

const PaymentMethodDisplay = ({ paymentMethod, paymentMethodDetails }) => {
  // Parse payment method details if it's a string
  let details = paymentMethodDetails;
  if (typeof paymentMethodDetails === 'string') {
    try {
      details = JSON.parse(paymentMethodDetails);
    } catch (e) {
      details = null;
    }
  }

  const getCardLogo = (cardType) => {
    const cardTypeLower = cardType?.toLowerCase() || '';
    
    if (cardTypeLower.includes('visa')) {
      return (
        <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="25" rx="4" fill="#1434CB"/>
          <path d="M17.5 8.5L15.5 16.5H13.5L15.5 8.5H17.5ZM28.5 8.5L26.5 16.5H24.5L26.5 8.5H28.5ZM20.5 8.5L18.5 16.5H16.5L18.5 8.5H20.5Z" fill="white"/>
        </svg>
      );
    } else if (cardTypeLower.includes('mastercard') || cardTypeLower.includes('master')) {
      return (
        <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="25" rx="4" fill="#EB001B"/>
          <circle cx="15" cy="12.5" r="6" fill="#F79E1B"/>
          <circle cx="20" cy="12.5" r="6" fill="#FF5F00"/>
        </svg>
      );
    } else if (cardTypeLower.includes('rupay')) {
      return (
        <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="25" rx="4" fill="#0074B6"/>
          <path d="M20 8L22 12L20 16L18 12L20 8Z" fill="white"/>
        </svg>
      );
    } else if (cardTypeLower.includes('amex') || cardTypeLower.includes('american')) {
      return (
        <svg width="40" height="25" viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="25" rx="4" fill="#006FCF"/>
          <path d="M20 10L22 15L20 20L18 15L20 10Z" fill="white"/>
        </svg>
      );
    }
    return null;
  };

  const getUPIIcon = () => {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="18" fill="#5F259F"/>
        <path d="M20 12L25 20L20 28L15 20L20 12Z" fill="white"/>
      </svg>
    );
  };

  if (paymentMethod === 'cash_on_delivery' || paymentMethod === 'Cash on Delivery') {
    return (
      <div className="payment-method-display">
        <div className="payment-method-icon cod-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
          </svg>
        </div>
        <span className="payment-method-text">Cash on Delivery</span>
      </div>
    );
  }

  if (details) {
    if (details.type === 'upi') {
      return (
        <div className="payment-method-display">
          <div className="payment-method-icon upi-icon">
            {getUPIIcon()}
          </div>
          <div className="payment-method-info">
            <span className="payment-method-text">UPI</span>
            {details.vpa && (
              <span className="payment-method-detail">{details.vpa}</span>
            )}
          </div>
        </div>
      );
    } else if (details.type === 'card') {
      const cardLogo = getCardLogo(details.card_type || details.card_network);
      return (
        <div className="payment-method-display">
          <div className="payment-method-icon card-icon">
            {cardLogo || (
              <svg width="40" height="25" viewBox="0 0 40 25" fill="none">
                <rect width="40" height="25" rx="4" fill="#1F1F1F"/>
                <rect x="5" y="8" width="30" height="2" rx="1" fill="white"/>
                <rect x="5" y="15" width="20" height="2" rx="1" fill="white"/>
              </svg>
            )}
          </div>
          <div className="payment-method-info">
            <span className="payment-method-text">
              {details.card_type ? details.card_type.toUpperCase() : 'Card'}
              {details.card_last4 && ` •••• ${details.card_last4}`}
            </span>
            {details.card_name && (
              <span className="payment-method-detail">{details.card_name}</span>
            )}
          </div>
        </div>
      );
    } else if (details.type === 'netbanking') {
      return (
        <div className="payment-method-display">
          <div className="payment-method-icon netbanking-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" fill="currentColor"/>
            </svg>
          </div>
          <div className="payment-method-info">
            <span className="payment-method-text">Net Banking</span>
            {details.bank && (
              <span className="payment-method-detail">{details.bank}</span>
            )}
          </div>
        </div>
      );
    } else if (details.type === 'wallet') {
      return (
        <div className="payment-method-display">
          <div className="payment-method-icon wallet-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8h16v10zm-4-7h-4v-2h4v2z" fill="currentColor"/>
            </svg>
          </div>
          <div className="payment-method-info">
            <span className="payment-method-text">Wallet</span>
            {details.wallet && (
              <span className="payment-method-detail">{details.wallet}</span>
            )}
          </div>
        </div>
      );
    }
  }

  // Fallback for unknown payment methods
  return (
    <div className="payment-method-display">
      <div className="payment-method-icon default-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
        </svg>
      </div>
      <span className="payment-method-text">{paymentMethod || 'Online Payment'}</span>
    </div>
  );
};

export default PaymentMethodDisplay;
